import {
    parse
} from "@babel/core";

function buildForm(form) {
    const data = {};
    const inputs = form.querySelectorAll("input:not([type='checkbox'])");
    const selects = form.querySelectorAll("select");
    const checkboxes = form.querySelectorAll("input[type='checkbox']");
    let areErrors = false;

    inputs.forEach(input => {
        if (input.getAttribute("data-max")) {
            if (parseFloat(input.value) > parseFloat(input.getAttribute("data-max"))) {
                input.classList.add("input__error");
                input.parentElement.querySelector(".input__error__message").style.display = "block";
                areErrors = true;
            } else {
                input.classList.remove("input__error");
                input.parentElement.querySelector(".input__error__message").style.display = "none";
            }
        }
        if (input.getAttribute("data-min")) {
            if (parseFloat(input.value) < parseFloat(input.getAttribute("data-min"))) {
                input.classList.add("input__error");
                input.parentElement.querySelector(".input__error__message").style.display = "block";
                areErrors = true;
            } else {
                input.classList.remove("input__error");
                input.parentElement.querySelector(".input__error__message").style.display = "none";
            }
        }
    });



    if (areErrors) {
        const firstErrorPos = document.querySelector(".input__error").offsetHeight;
        scrollTo({
            top: firstErrorPos,
            behavior: "smooth"
        })
    } else {
        inputs.forEach(input => {
            data[input.name] = input.value;
        });

        if (selects.length) {
            selects.forEach((select, i) => {
                data[select.name] = select.querySelector("option:checked").value;
            });
        }

        if (checkboxes.length) {
            checkboxes.forEach((checkbox, i) => {
                if (checkbox.checked) {
                    data[checkbox.name] = checkbox;
                }
            });
        }

        return data;
    }
}

function handleTabs(e) {
    const target = e.target.getAttribute("data-bs-target");
    const tab = document.querySelector(`${target}`);
    // Handle nav active class
    e.target.parentElement.parentElement.querySelector(".active").classList.remove("active");
    e.target.classList.add("active");

    // Handle containers active class
    tab.parentElement.querySelector(".active").classList.remove("show");
    tab.parentElement.querySelector(".active").classList.remove("active");
    tab.classList.add("active");
    tab.classList.add("show");
}

const device = {
    isMobile: function () {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i,
        ];

        return toMatch.some((toMatchItem) =>
            navigator.userAgent.match(toMatchItem)
        );
    }
};

const format = {
    date(incomingDate, format = "dd/mm/aaaa") {
        const type = format.toLocaleLowerCase();
        let dateToFormat = null;

        if (typeof incomingDate == "string") {
            const cleanDate = incomingDate.replaceAll("-", "/");
            const splitted = cleanDate.split("/");

            if (splitted[0].length === 4) {
                dateToFormat = `${splitted[0]}/${splitted[1]}/${splitted[2]}`;
            } else if (splitted[2].length === 4) {
                dateToFormat = `${splitted[2]}/${splitted[1]}/${splitted[0]}`;
            }
        } else if (typeof incomingDate == "object") {
            dateToFormat = incomingDate;
        }

        const d = new Date(dateToFormat);
        const month = d.getMonth() < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
        const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();

        switch (type) {
            case "dd/mm/aaaa":
                return `${day}/${month}/${d.getFullYear()}`;

            case "aaaa/mm/dd":
                return `${d.getFullYear()}/${month}/${day}`;

            case "aaaa-mm-dd":
                return `${d.getFullYear()}-${month}-${day}`;

            case "mm-dd-aaaa":
                return `${month}-${day}-${d.getFullYear()}`;

            default:
                break;
        }
    },

    money(number) {
        return new Intl.NumberFormat("es-MX", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number)
    }
};

const form = {
    build: function (form) {
        const inputs = form.querySelectorAll("input:not([type='checkbox']):not([type='radio'])");
        const checkboxes = form.querySelectorAll("input[type='checkbox']");
        const radios = form.querySelectorAll("input[type='radio']");
        const selects = form.querySelectorAll("select");
        const data = {};

        inputs.forEach(input => {
            if (input.name) {
                data[input.name] = input.value;
            }
        });

        checkboxes.forEach(checkbox => {
            if (checkbox.name) {
                data[checkbox.name] = checkbox.checked;
            }
        });

        radios.forEach(radio => {
            if (radio.name) {
                data[radio.name] = radio.value
            }
        });

        selects.forEach(select => {
            if (select.name) {
                data[select.name] = select.selectedOptions[0].value;
            }
        })

        return data;
    },

    validate: function (form) {
        const errors = form.querySelector(".input__error");
        if (errors) {
            const posY = errors.offsetTop;
            scrollTo({
                top: posY,
                left: 0,
                behavior: 'smooth'
            });
            return false;
        } else {
            return true;
        }
    }
}

const validate = {
    date: {
        month(date) {
            const regex = /^(0[1-9]|1[0-2])$/;
            return regex.test(date);
        },
        year(date) {
            const regex = /^(19[5-9]\d|20[0-4]\d|2050)$/;
            return regex.test(date);
        },
        day(date) {
            const regex = /^(0[1-9]|[12]\d|3[01])$/;
            return regex.test(date);
        }
    },

    phone(number) {
        const regex = /^.{8,10}$/;
        return regex.test(number);
    },

    string(chars) {
        const regex = /^[A-Z]+$/i;
        return regex.test(chars.replaceAll(" ", ""));
    },
    cp(number) {
        const regex = /^.{5}$/;
        return regex.test(number);
    },
    email(email) {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(email);
    },

    password(password) {
        const regex = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/;

        if (password.length >= 8 && regex.test(password)) {
            return true
        } else return false;
    }
};

const convert = {
    // Convert PDF to Base64
    convertFileToBase64(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = function () {
                resolve(reader.result.split(',')[1]);
            }
            reader.onerror = reject;
            reader.readAsDataURL(file);
        })
    }
}

const date = {
    resta(dateStart, dateEnd) {
        const date1 = new Date(dateStart);
        const date2 = new Date(dateEnd);
        const resta = date2.getTime() - date1.getTime();
        return resta / (1000 * 3600 * 24);
    },
    getAge(dateString) {
        const today = new Date();
        const birthDate = new Date(dateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }
}

const extensionImage = {
    getExtension(type) {
        return (type === "image/jpeg") ? ".jpeg" : ".png";
    }
}

export {
    buildForm,
    handleTabs,
    device,
    format,
    form,
    validate,
    convert,
    date,
    extensionImage
}